import { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import API_BASE_URL from "../config/api";
import "./HeaderPath.css";
function HeaderPath() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const [isAccountOpen, setIsAccountOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const accountRef = useRef(null);

 const [open, setOpen] = useState(false);


const closeMenu = () => {
  const menu = document.querySelector(".nav-menus-wrapper");
  if (menu) {
    menu.classList.remove("nav-menus-wrapper-open");
  }
};

  const normalizeUser = (u) => {
    if (!u) return null;
    return {
      id: u.id ?? u.userid ?? u.userId ?? null,
      name: u.name ?? u.fullname ?? u.username ?? "",
      picture_url:
        u.picture_url ??
        (u.profile_pic
          ? String(u.profile_pic).startsWith("http")
            ? u.profile_pic
            : `${API_BASE_URL}/${String(u.profile_pic).replace(/^\/+/, "")}`
          : ""),
      city: u.city_title ?? u.city ?? u.city_name ?? u.location ?? "",
    };
  };

  useEffect(() => {
    try {
      const raw = sessionStorage.getItem("user");
      if (raw) {
        const parsed = JSON.parse(raw);
        setUser(normalizeUser(parsed));
        setIsLoggedIn(true);
      } else {
        setUser(null);
        setIsLoggedIn(false);
      }
    } catch (e) {
      console.warn("HeaderPath: invalid session user", e);
      setUser(null);
      setIsLoggedIn(false);
    }

    const onUserUpdated = (ev) => {
      const payload = ev?.detail ?? null;
      if (payload) {
        try {
          sessionStorage.setItem("user", JSON.stringify(payload));
        } catch (e) {
          console.warn("HeaderPath: failed to write sessionStorage", e);
        }
        setUser(normalizeUser(payload));
        setIsLoggedIn(true);
      } else {
        try {
          const raw2 = sessionStorage.getItem("user");
          if (raw2) setUser(normalizeUser(JSON.parse(raw2)));
          else {
            setUser(null);
            setIsLoggedIn(false);
          }
        } catch {
          setUser(null);
          setIsLoggedIn(false);
        }
      }
    };

    const onStorage = (ev) => {
      if (ev.key === "user") {
        try {
          if (ev.newValue) {
            setUser(normalizeUser(JSON.parse(ev.newValue)));
            setIsLoggedIn(true);
          } else {
            setUser(null);
            setIsLoggedIn(false);
          }
        } catch {
          setUser(null);
          setIsLoggedIn(false);
        }
      }
    };

    window.addEventListener("userUpdated", onUserUpdated);
    window.addEventListener("storage", onStorage);

    return () => {
      window.removeEventListener("userUpdated", onUserUpdated);
      window.removeEventListener("storage", onStorage);
    };
  }, []);

  // Close account menu when route changes
  useEffect(() => {
    setIsAccountOpen(false);
  }, [location.pathname]);

  // Click outside to close account menu
  useEffect(() => {
    const onClickOutside = (e) => {
      if (isAccountOpen && accountRef.current && !accountRef.current.contains(e.target)) {
        setIsAccountOpen(false);
      }
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, [isAccountOpen]);

  const closeAccountMenu = () => setIsAccountOpen(false);

  const handleLogout = () => {
    sessionStorage.removeItem("user");
    setUser(null);
    setIsLoggedIn(false);
    closeAccountMenu();
    navigate("/login");
  };

  const profileImage =
    user?.picture_url && String(user.picture_url).trim() !== ""
      ? user.picture_url
      : `${process.env.PUBLIC_URL}/assets/img/profile.png`;

  // helper to compute active class
  const isActive = (path) => {
    // exact match for root
    if (path === "/") return location.pathname === "/" ? "active" : "";
    // other paths: treat a prefix match as active (e.g., /mocktest/123)
    return location.pathname.startsWith(path) ? "active" : "";
  };

  return (
    <div id="main-wrapper">
      <div className="header header-light head-fixed change-logo">
        <div className="container">
          <nav id="navigation" className="navigation navigation-landscape">
            <div className="nav-header">
              <Link className="nav-brand static-logo" to="#">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/img/the-pilot-guide-logo.png`}
                  className="logo"
                  alt="Pilot Guide"
                />
              </Link>
               <Link className="nav-brand fixed-logo" to="#">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/img/the-pilot-guide-logo.png`}
                  className="logo"
                  alt="Pilot Guide"
                />
              </Link>
              <div className={`nav-toggle ${open ? "active" : ""}`}
  onClick={() => setOpen(!open)}>
  <span></span>

        </div>
           
            </div>

            <div className="nav-menus-wrapper" style={{ display: open ? "block" : "" }}>
              <ul className="nav-menu">
{!isLoggedIn && (
  <>
    <li className={isActive("/")}>
      <Link to="/"  onClick={closeMenu}>Home</Link>
    </li>
    <li className={isActive("/about")}>
      <Link to="/about" onClick={closeMenu}>About</Link>
    </li>
    <li className={isActive("/notification")}>
      <Link to="/notification" onClick={closeMenu}>Announcement</Link>
    </li>
    <li className={isActive("/contact")}>
      <Link to="/contact" onClick={closeMenu}>Contact</Link>
    </li>
    <Link to="/signup" className="mobile-signup-btn " onClick={closeMenu}>
          <i className="bi bi-person-circle me-2"></i>Sign Up
            </Link>
            <Link to="/login" className="mobile-login-btn" onClick={closeMenu}>
          <i className="fas fa-sign-in-alt me-2"></i>Sign In
            </Link>
  </>
)}
                 
              </ul>

              <ul className="nav-menu nav-menu-social align-to-right">
                {isLoggedIn ? (
                  <li ref={accountRef}>
                    <div className="btn-group account-drop">
                      <button
                        type="button"
                        className="btn d-flex align-items-center gap-2"
                        aria-haspopup="true"
                        aria-expanded={isAccountOpen ? "true" : "false"}
                        onClick={() => setIsAccountOpen((prev) => !prev)}
                      >
                        <span className="fw-bold">{user?.name || "User"}</span>
                        <div
                          style={{
                            width: "36px",
                            height: "36px",
                            borderRadius: "50%",
                            overflow: "hidden",
                            backgroundColor: "#eee",
                          }}
                        >
                          <img
                            src={profileImage}
                            alt="User"
                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                            onError={(e) => {
                              e.currentTarget.onerror = null;
                              e.currentTarget.src = `${process.env.PUBLIC_URL}/assets/img/profile.png`;
                            }}
                          />
                        </div>
                      </button>

                      <div
                        className={
                          "dropdown-menu pull-right animated flipInX" +
                          (isAccountOpen ? " show" : "")
                        }
                      >
                        <div className="drp_menu_headr bg-main d-flex justify-content-between align-items-center px-3 py-2">
                          <h4 className="mb-0 text-white">Hi, {user?.name || "User"}</h4>
                          <button
                            type="button"
                            className="btn btn-whites btn-sm"
                            onClick={handleLogout}
                          >
                            Logout
                          </button>
                        </div>
                        <ul className="px-2 py-1">
                          <li>
                            <Link to="/StudentDashboard" onClick={closeAccountMenu}>
                              <i className="fa-solid fa-house me-2"></i>Dashboard
                            </Link>
                          </li>
                          <li>
                            <Link to="/profile" onClick={closeAccountMenu}>
                              <i className="fa fa-user-tie me-2"></i>My Profile
                            </Link>
                          </li>
                          <li>
                            <Link to="/enrollments" onClick={closeAccountMenu}>
                              <i className="fa fa-bookmark me-2"></i>Enrollments
                            </Link>
                          </li>
                          <li>
                            <Link to="/profile/password-change" onClick={closeAccountMenu}>
                              <i className="fa fa-unlock-alt me-2"></i>Change Password
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                ) : (
                  <>
                    <li>
                      <Link to="/login">
                        <i className="fas fa-sign-in-alt me-2"></i>Sign In
                      </Link>
                    </li>
                    <li className="list-buttons ms-2">
                      <Link to="/signup">
                        <i className="bi bi-person-circle me-2"></i>Sign Up
                      </Link>
                    </li>
                  </>
                )}
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
}

export default HeaderPath;
